import { api } from "../Apis/interceptor";

export const list = function (cust_id, sortBy, orderBy) {
  return api.get(
    "/api/v1/branchlist/" + cust_id + "/" + sortBy + "/" + orderBy
  );
};

export const createNew = function (branchData) {
  return api.post("/api/v1/createBranch/", branchData);
};

export const getBranch = function (branch_id) {
  return api.get("/api/v1/branch/" + branch_id);
};

export const updateBranch = function (branch_id, branchData) {
  return api.put("/api/v1/branch/" + branch_id, branchData);
};

export const deleteBranch = function (id) {
  return api.delete("/api/v1/branch/" + id);
};

export const filter = function (
  skip,
  limit,
  cust_id,
  pattern,
  sortBy,
  orderBy
) {
  pattern = pattern == "All" ? "" : pattern;
  return api.get("/api/v1/branch_filter", {
    params: {
      skip: skip,
      limit: limit,
      cust_id: cust_id,
      pattern: pattern,
      sortBy: sortBy,
      orderBy: orderBy,
    },
  });
};

export const getPageLike = function (cust_id, pattern, sortBy, orderBy) {
  return api.get(
    "/api/v1/branchLike/" +
      cust_id +
      "/" +
      pattern +
      "/" +
      sortBy +
      "/" +
      orderBy
  );
};
